module.exports = __webpack_public_path__ + "static/media/student_small.e40faadd.jpg";